import {
  GreyGrey10,
  GreyGrey60,
  GreyGrey80,
  Primary13SemiBold,
  TextFieldInput,
  IconXMark,
  Box,
  Flex
} from '@sequencehq/core-components'
import { usePhase } from '../../utils/usePhase'
import { useOutsideClick } from '@sequencehq/utils'
import { atom, useAtom } from 'jotai'
import { RenderPhaseDates } from './RenderPhaseDate'
import { useRef } from 'react'

/**
 * To be mounted into an appropriate scope, to enable other
 * components to control the editing state of this field.
 */
export const isEditingPhaseNameAtom = atom<boolean>(false)

export const PhaseLabel = (props: { phaseId: string }) => {
  const { phase, updatePhase } = usePhase(props.phaseId)
  const [isEditing, setIsEditing] = useAtom(isEditingPhaseNameAtom)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useOutsideClick({
    ref: wrapperRef,
    handler: () => setIsEditing(false)
  })

  return (
    <Flex
      {...Primary13SemiBold}
      color={GreyGrey80}
      gap="8px"
      width="100%"
      onClick={() => setIsEditing(true)}
      _hover={{ backgroundColor: !isEditing ? GreyGrey10 : undefined }}
      padding={isEditing ? 0 : '8px'}
      alignItems="center"
      cursor={isEditing ? undefined : 'pointer'}
      data-testid={`reviewPricing.phase.${phase.id}.label`}
    >
      {isEditing ? (
        <Flex ref={wrapperRef} gap="4px" alignItems="center">
          <TextFieldInput
            autoFocus
            width="360px"
            value={phase.name}
            onChange={e => updatePhase({ name: e.target.value })}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                setIsEditing(false)
              }
            }}
            data-testid={`reviewPricing.phase.${phase.id}.label.input`}
          />
          <IconXMark
            color={GreyGrey60}
            cursor="pointer"
            onClick={e => {
              e.stopPropagation()
              setIsEditing(false)
            }}
            data-testid={`reviewPricing.phase.${phase.id}.label.close`}
          />
        </Flex>
      ) : (
        phase.name && (
          <Box
            cursor="pointer"
            _hover={{
              backgroundColor: GreyGrey10
            }}
          >
            {phase.name}
          </Box>
        )
      )}

      {!isEditing && (
        <RenderPhaseDates
          startDate={phase.startDate}
          endDate={phase.endDate}
          theme={isEditing || phase.name ? 'secondary' : 'primary'}
        />
      )}
    </Flex>
  )
}
